import React from 'react';
import Landing from './Landing';
import LandingLayout from '../../components/Layout/LandingLayout';

import { getListingFields } from '../../actions/getListingFields';
import messages from '../../locale/messages';
import getLandingMessage from './getLandingMessage';

export default async function action({ store }) {
  const title = `${getLandingMessage(store, messages.newLandingSiteName)} - ${getLandingMessage(store, messages.newLandingHeroOverline)}`;
  const description = getLandingMessage(store, messages.newLandingMetaDescription);
  const listingFields = store.getState().listingFields.data;

  if (listingFields === undefined) {
    store.dispatch(getListingFields());
  }

  return {
    title,
    description,
    listingFields,
    chunk: 'landing',
    component: (
      <LandingLayout>
        <Landing />
      </LandingLayout>
    ),
  };
};
